// removed by extract-text-webpack-plugin
module.exports = {"mainDiv":"_1q4zROH00YCPeGr86JzxEw","mainImg":"Fekp5UxnLp0W4WMPD4KZl","subtitle":"VOmCA7zfk3QbynyhmHow0","text":"_30q-hJqpMuovOouRRwehwq","spacer":"_3rReRVL-euhQweEey6004j"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Splatanie/Splatanie.css
// module id = 33
// module chunks = 0